import React from 'react';
import {Platform} from 'react-native';
import Svg, {Circle, Text} from 'react-native-svg';

import theme from '../../../style/theme';
import {fontFamily} from '../../ui-controls/Text';

import {SvgBadgeComponent} from './types';

const badge = theme.size.badge;
const svgFontStack = `${fontFamily}, Helvetica Neue, Helvetica, Arial, sans-serif`;

const HbTcBadge: SvgBadgeComponent = ({price, text = '', size}) => {
  const hasText = text.trim().length > 0;

  const VIEWBOX_SIZE = 48;
  const CENTER = 24;

  const textFontWeight = Platform.OS === 'web' ? 'normal' : '600';
  const priceFontWeight = Platform.OS === 'web' ? '500' : '700';

  const textY = badge.textY;
  const priceY = hasText ? badge.priceYWithText : badge.priceYNoText;

  const fontSize = hasText && text.length > 8 ? badge.titleFontSizeLong : badge.titleFontSize;

  return (
    <Svg
      viewBox={`0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
      width={size || '100%'}
      height={size || '100%'}>
      <Circle cx={CENTER} cy={CENTER} r={CENTER} fill={badge.color} />
      {hasText ? (
        <Text
          fill="#FFFFFF"
          fontFamily={svgFontStack}
          fontSize={fontSize}
          fontWeight={textFontWeight}
          x={CENTER}
          y={textY}
          textAnchor="middle">
          {text.toUpperCase()}
        </Text>
      ) : null}
      <Text
        fill="#FFFFFF"
        fontFamily={svgFontStack}
        fontSize={badge.priceFontSize}
        fontWeight={priceFontWeight}
        x={CENTER}
        y={priceY}
        textAnchor="middle">
        {price}
      </Text>
    </Svg>
  );
};

export default HbTcBadge;
